import { Link } from "react-router-dom";
import { Ic } from "../icons.jsx";

export default function CtaBand() {
  return (
    <section className="cta">
      <h2>Pronto a digitalizzare il tuo noleggio?</h2>
      <p>Inizia la prova gratuita di 14 giorni. Nessuna carta di credito richiesta.</p>
      <Link to="/register" className="btn btn-w btn-lg" style={{ textDecoration: "none", justifyContent: "center" }}>
        Inizia gratis — 14 giorni <Ic n="arrow" s={18} />
      </Link>
    </section>
  );
}
